import ResetPassword from './ResetPassword'
export { ResetPassword }
export default ResetPassword
